import React from 'react';
import LocationTemplate from './LocationTemplate';

const WashingtonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Washington"
      stateName="North Carolina"
      countyName="Beaufort"
      zipCodes={["27889", "27890"]}
      latitude={35.5465}
      longitude={-77.0519}
      population={9619}
      historicalFact="First town in America named after George Washington (1776)."
      nearbyTowns={[
        "New Bern, NC",
        "Greenville, NC",
        "Kinston, NC",
        "Plymouth, NC",
        "Williamston, NC",
        "Elizabeth City, NC",
        "Morehead City, NC",
        "Oriental, NC"
      ]}
    />
  );
};

export default WashingtonPage;